import { useTranslation } from "react-i18next";
import sky from "../../assets/brand/dashboard-kl-skyline.webp";
import logo from "../../assets/brand/sea-games-2027-logo.svg";

/** Her footer band (`.dft`): the Games logo, the slogan, a faint KL skyline. Bleeds to the shell's edges. */
export function FooterBand() {
	const { t } = useTranslation("dashboard");
	return (
		<footer className="db-ft">
			<img className="db-ft__logo" src={logo} alt={t("footer.logoAlt")} decoding="async" />
			<p>
				<span>{t("footer.slogan")}</span>
				<span>{t("footer.sloganTranslated")}</span>
			</p>
			<img className="db-ft__sky" src={sky} alt="" decoding="async" />
		</footer>
	);
}
